import { useEffect, useRef } from 'react'

import { LineShopEventId, LineShopProduct } from './types'
import { trackLineShopEvent } from './trackLineShopEvent'

// LINE 購物規範：
// - event 2 (BROWSE_PAGE): 非商品頁瀏覽超過 3 秒
// - event 5 (VIEW_PRODUCT): 商品詳細頁瀏覽超過 3 秒
const DWELL_MS = 3000

type Args = {
  eventId: LineShopEventId.BROWSE_PAGE | LineShopEventId.VIEW_PRODUCT
  // 等於 true 時才掛 timer，方便等資料載入完再開始計時
  enabled?: boolean
  products?: LineShopProduct[]
}

const buildProductKey = (products?: LineShopProduct[]): string => {
  if (!products?.length) return ''
  return products.map((p) => p.product_id).join(',')
}

export const useLineShopPageView = ({ eventId, enabled = true, products }: Args): void => {
  // 用 ref 持有最新 products，避免 array 每次 render 都換 reference 而重新計時
  const productsRef = useRef<LineShopProduct[] | undefined>(products)
  productsRef.current = products

  const productKey = buildProductKey(products)

  useEffect(() => {
    if (!enabled) return
    if (typeof window === 'undefined') return

    const timer = window.setTimeout(() => {
      const redirectUrl = window.location.href

      if (eventId === LineShopEventId.VIEW_PRODUCT) {
        const latestProducts = productsRef.current
        if (!latestProducts?.length) return
        trackLineShopEvent({ eventId, redirectUrl, products: latestProducts })
        return
      }

      trackLineShopEvent({ eventId, redirectUrl })
    }, DWELL_MS)

    return () => window.clearTimeout(timer)
  }, [eventId, enabled, productKey])
}
